export const loginUrl = "/api/dashboard/login";

export const logoutUrl = "/api/phlebotomists-portal/logout-user/";

export const createAccountUrl = "/api/dashboard/dashboard-account";

export const consentPageUrl = "/api/dashboard/account-consent/";

export const resetPasswordUrl = "/api/dashboard/dashboard-forgot-password";

export const myResultUrl = "/api/dashboard/test-kits/";

export const postPersonalDetailsApiUrl = `/api/dashboard/activate/personal-details`;

export const ResultByBioMarkerUrl = "/api/dashboard/results-by-biomarkers/";

export const setPasswordUrl = "/api/dashboard/dashboard-reset-password";

export const assessmentValidateUrl = "/api/dashboard/assessement/validate";

export const assessmentStatusUrl = "/api/dashboard/assessment/status/";

export const assessementFinalSubmitUrl = "/api/dashboard/assessment/blood";

export const testKitDetailsUrl = "http://localhost:3005/testKitDetails";

export const wellnessReportUrl = (id) => `/api/dashboard/report/dna/${id}`;

export const phlebotomySuccessUrl = "http://localhost:3005/phlebotomySuccessPage";

export const rejectBookingUrl = (bid) => `http://localhost:3005/rejectBooking=${bid}`;

export const postCoderurl = (trimmedCode) => `/api/dashboard/post-code/?postcode=${encodeURIComponent(trimmedCode)}`;

export const countriesUrl = "/api/dashboard/countries";

export const editAccountDetailsUrl = (userId) => `/api/dashboard/edit-account-details/${userId}`;

export const summaryUrl = "/api/dashboard/summary/";

export const bookingUrl = "/api/dashboard/bookings/";

export const royalMailTrackingUrl = (trakingNumber) => `https://www.royalmail.com/track-your-item#/tracking-results/${trakingNumber}`

export const confirmTestTypeUrl = "/api/dashboard/test-type-confirm/";

export const phlebotomyGetConsentUrl = (bid) => `/api/dashboard/booking/consent/${bid}`;

export const phlebotomyPostConsentUrl = "/api/dashboard/consent/";

export const accountSettings = "/api/dashboard/edit-password/";

export const orderRetestKit = "/api/dashboard/order-retest-kit/";

export const phlebotomyAssessmentStatusUrl = (bid) => `/api/dashboard/assessment/status/booking/${bid}`;

export const getUserHealthInformtion = (userId) => `/api/dashboard/assessment/account/${userId}`;

export const phlebotomyAssessementFinalSubmit = (bid) => `/api/dashboard/assessment/blood/booking/${bid}`;

export const downloadDnaPdf = (id) => `/api/dashboard/download-report-pdf/${id}/`;

export const downloadDnaTxt = (id) => `/api/dashboard/download-report-txt/${id}/`;

export const barcodeDataApi = (bcode) => `/api/dashboard/historical-biomarker-data/${bcode}/`;

export const dirtyFromConfirmation =
    "Are you sure you want to leave without saving changes? Any unsaved modifications will be lost.";

export const christmasMessage = "View our Christmas and New Year service hours";

export const mayHolidayMessage = "May 2026 opening hours";

export const easterMessage = "Easter Holiday Opening Hours";

export const mhcHolidaysMessage = "Bank Holiday Hours";

export const networkError = "No internet connection. Please check your connection.";

export const accessError = "Access denied: please complete the previous steps";

export const blockedKitError = "This test kit has been blocked by our quality team and cannot be used. Please contact customer support for a replacement.";

export const userNotFound = "User details not found in Users table.";

export const bloodReportDownload = '/api/dashboard/get-blood-pdf-report/';

export const sendOtpUrl = `/api/dashboard/send-login-otp`;

export const verifyOtpUrl = `/api/dashboard/verify-login-otp`;

export const bloodCholesterol = 'blood-cholesterol';
export const bloodEnergy = 'blood-energy';
export const bloodGeneral = 'blood-general';
export const bloodHeart = 'blood-heart';
export const bloodThyroid = 'blood-thyroid';
export const bloodVitamins = 'blood-vitamins';
export const bloodWeight = 'blood-weight';
export const bloodMaleSexHealth = 'blood-male-sex-health';
export const bloodFemaleSexHealth = 'blood-female-sex-health';
export const bloodMenopause = 'blood-menopause';
export const bloodPolycystic = 'blood-polycystic';
export const bloodVitaminB12 = 'blood-vitamin-b12';
export const bootsBloodVitaminB12 = 'boots-blood-vitamin-b12';
export const bloodTestosterone = 'blood-testosterone';
export const bloodErectile = "blood-erectile"
export const dnaWeight = "dna-weight"
export const dnaGlucose = "dna-glucose"
export const dnaIntolerances = "dna-intolerances"
export const dnaHeart = "dna-heart"
export const dnaVitamins = "dna-vitamins"
export const bloodFertility = "blood-fertility"
export const bloodProgresterone = "blood-progesterone"
export const bootsThyroid = 'boots-blood-thyroid';
export const bootsCholesterol = 'boots-blood-cholesterol';
export const bootsEnergy = 'boots-blood-energy';
export const bootsGeneral = 'boots-blood-general';
export const bootsVitamins = 'boots-blood-vitamins';
export const bootsWeight = 'boots-blood-weight';
export const cookieExpirationTime = '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'

export const activationSteps = {
    "/confirm-details/": 1,
    "/time-administered/": 2,
    "/assessment/":3,
}

export const activationStepsSecondary = {
    "/secondary-barcode/": 1,
    "/confirm-details/": 2,
    "/time-administered/": 3,
    "/assessment/":4,
}

export const activationStepsSH = {
    "/secondary-barcode/": 1,
    "/confirm-details/": 2,
    "/sh-consent/": 3,
    "/time-administered/": 4,
    "/assessment/": 5,
}

export const phlebotomistSteps = {
    "/registration/": 1,
    "/confirm-details/": 2,
    "/assessment/": 3,
}

